import List from '../list/List'

const ParticipantListPage = () => {
  return <List/>
}
export default ParticipantListPage